const { createSlice } = require('@reduxjs/toolkit');

const logouttoggleSlice = createSlice({
    name: "logouttoggle",
    initialState: {
        status: false,
    },
    reducers: {
        setlogouttoggle(state) {
            // Toggle the status each time this reducer is called
            state.status = !state.status;
        }
    },
});

export const { setlogouttoggle } = logouttoggleSlice.actions;
export default logouttoggleSlice.reducer;
